import { styled } from '@styles';

export const HomePage = styled.div`
  min-height: 100vh;
`;
